/* eslint-disable */
import Vue from "vue";
import { AxiosRequestConfig, AxiosResponse, AxiosInstance } from "axios";
import store from "@/store";

declare module "vue/types/vue" {
  interface VueConstructor {
    $axios: AxiosInstance;
  }
}

export namespace Http {
  export class ApiJwtService {
    constructor() {
      this.request();
      this.response();
    }

    protected request() {
      Vue.axios.interceptors.request.use(
        (config: AxiosRequestConfig) => {
          const token = store.getters["auth/getToken"];
          if (token != "") {
            config.headers.common["Authorization"] = "Bearer " + token;
          }
          return config;
        },
        (err: any) => {
          return Promise.reject(err);
        }
      );
    }

    protected response() {
      Vue.axios.interceptors.response.use(
        (response: AxiosResponse) => {
          return response;
        },
        (error: any) => {
          let errMsg: string = "";
          let serverError: boolean = true;
          //console.log(error.response);
          
          if (error.response) {
            switch (error.response.status) {
              case 400:
                errMsg = this.getMensajeErrors(error.response.data);
                break;
              case 500:
                errMsg = error.response.data;
                break;
            }
          } else {
            errMsg = "No se puede conectar con el servidor";
          }

          if (serverError) Vue.prototype.$toast.error(errMsg);
          else Vue.prototype.$toast.warning(errMsg);

          return Promise.reject(error);
        }
      );
    }

    protected getMensajeErrors(data: any): string{
      if(data.errors){
        if(data.errors.usuario) return data.errors.usuario[0];
        if(data.errors.password) return data.errors.password[0];
      }
      return data;
    }
  }
}
